import _ from 'lodash'
import moment from 'moment'

export const encryptCellphone = (str) => {
  str = str ? `${str.slice(0, 4)}****${str.slice(-3)}` : ''
  return str
}

export const replaceBankcardNumWithStar = (str) => {
  str = `${str}`
  // return '*'.repeat(str.length - 4) + str.slice(-4)
  return str.slice(0, str.length - 4).replace(/\d/g, '*') + str.slice(-4)
}

export const formatDate = (str, format) => moment(str).format(format)

export const addThousandSign = (num, digits = 0) => {
  num = Number(num)
  return !_.isNaN(num) ? (`${num.toFixed(digits)}`).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,') : ''
}

export const addBankcardNumSpaces = (str) => {
  const spaceRE = /(\s*)/g  // 正则-所有空格
  const spaceEndRE = /(\s*$)/g  // 正则-末位空格
  const spaceStr = str.replace(spaceRE, '').replace(/(\d{4})(?=\d)/g, '$1 ')
  return spaceStr.replace(spaceEndRE, '') // 替换末位空格
}

export const formTime = (value) =>{ //    毫秒时间戳转换年月日
  var time=new Date(value);
  var year =time.getFullYear();
  var month=time.getMonth()+1;
  var day=time.getDate();
  var h = time.getHours();
  var mm = time.getMinutes();
  if(month<=9){
    month="0"+month;
  }
  if(day<=9){
    day="0"+day;
  }
  if(h<=9){
    h="0"+h;
  }
  if(mm<=9){
    mm="0"+mm;
  }
  return year+"-"+month+"-"+day;
}



// WEBPACK FOOTER //
// ./src/filters/index.js